import React from 'react';
import {
  Divider,
  Flex,
  Icon,
  List,
  ListItem,
  Text,
  VStack,
} from '@chakra-ui/react';
import { MdSpeed } from 'react-icons/md';
import { t } from '#i18n';

import { AccordionNav } from './AccordionNav';

export const StatsMenu = () => (
  <VStack marginTop={8}>
    <Flex width="full" paddingLeft={2}>
      <Icon as={MdSpeed} boxSize={5} marginRight={2} color="primary.100" />
      <Text fontSize="sm" fontWeight="bold" color="primary.100">
        {t('navmenu.statsMenu.title').toUpperCase()}
      </Text>
    </Flex>
    <Divider borderColor="primary.200" />
    <List width="full">
      <ListItem>
        <AccordionNav
          title={t('navmenu.statsMenu.pullRequestReviews')}
          paths={[
            {
              name: t('stats.pullRequestReviews.overview.title'),
              path: '/stats/pull-request-reviews/overview',
            },
            {
              name: t('stats.pullRequestReviews.overTime.title'),
              path: '/stats/pull-request-reviews/over-time',
            },
          ]}
        />
      </ListItem>
    </List>
  </VStack>
);
